import { tx } from "@/i18n/tx";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader } from "@/components/AppShell";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid" || data.status === "completed") { setStatus("paid"); return; }
      } catch (err) { console.debug(tx("Payment status poll not ready yet:"), err?.message || err); }
      tries += 1;
      if (tries > 8) { setStatus("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  if (status === "checking") return <Loader label={tx("Confermo il tuo abbonamento...")} />;

  return (
    <div className="anima-backdrop min-h-screen flex items-center justify-center px-7">
      <div className="w-full max-w-md text-center" data-testid="payment-success">
        <CheckCircle2 size={56} className="text-anima-sagedeep mx-auto mb-5" />
        <h1 className="font-serif text-4xl text-anima-ink mb-3">{status === "paid" ? tx("Grazie di cuore") : tx("Ci siamo quasi")}</h1>
        <p className="text-anima-muted mb-8">
          {status === "paid"
            ? tx("Il tuo abbonamento e attivo. Il tuo spazio di ascolto ti aspetta.")
            : tx("Il pagamento e in elaborazione. Il tuo accesso si attivera a breve.")}
        </p>
        <button onClick={() => navigate("/app")} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium">{tx("Torna alla home")}</button>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="anima-backdrop min-h-screen flex items-center justify-center px-7">
      <div className="w-full max-w-md text-center" data-testid="payment-cancel">
        <XCircle size={56} className="text-anima-muted mx-auto mb-5" />
        <h1 className="font-serif text-4xl text-anima-ink mb-3">{tx("Nessun problema")}</h1>
        <p className="text-anima-muted mb-8">{tx("Il pagamento e stato annullato. Puoi scegliere un piano quando ti sentirai pronta.")}</p>
        <div className="space-y-3">
          <button onClick={() => navigate("/pricing")} className="w-full rounded-full bg-anima-sagedeep text-anima-ivory py-4 font-medium">{tx("Vedi di nuovo i piani")}</button>
          <button onClick={() => navigate("/app")} className="w-full rounded-full border border-anima-ink/15 text-anima-ink py-4">{tx("Torna alla home")}</button>
        </div>
      </div>
    </div>
  );
}
